import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "welcome-name" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-user" }, null, -1)

import { computed } from 'vue';
import { useMsal } from '@/composition-api/useMsal';

export default /*#__PURE__*/_defineComponent({
  __name: 'WelcomeName',
  setup(__props) {

const { accounts } = useMsal();

const name = computed(() => {
  if (accounts.value.length > 0) {
    const name = accounts.value[0].name;
    if (name) {
      return name.split(' ')[0];
    }
  }
  return '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!!_unref(name))
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Velkommen, " + _toDisplayString(_unref(name)), 1))
      : _createCommentVNode("", true),
    _hoisted_3
  ]))
}
}

})